import React from 'react';
import { Form } from 'formik';
import { Col, Row } from 'reactstrap';
import FormInputField from '../../common/components/formFields/FormInputField';
import FormSelectField from '../../common/components/formFields/FormSelectField';
import { constantToSelect } from '../../common/helpers/constantToSelect';
import { DealerPositionName } from '../../constants/DealerPosition';

const dealerRole = constantToSelect(DealerPositionName);
const COMMON_FIELD_PROPS = {
  disabled: true,
  labelVariant: 'bordered',
};

function ProfileDetailsForm() {
  return (
    <div className="mt-3">
      <Row className="mt-4">
        <Col md={12} className="justify-content-center mr-auto ml-auto">
          <Form autoComplete="off" className="text-left">
            <Row className="justify-content-between">
              <Col md="6">
                <FormInputField name="firstName" label="First name" {...COMMON_FIELD_PROPS} />
              </Col>
              <Col md="6">
                <FormInputField name="lastName" label="Last name" {...COMMON_FIELD_PROPS} />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormSelectField
                  name="position"
                  label="Position"
                  options={dealerRole}
                  {...COMMON_FIELD_PROPS}
                />
              </Col>
              <Col md="6">
                <FormInputField name="email" label="E-mail" {...COMMON_FIELD_PROPS} />
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default ProfileDetailsForm;
